import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Log } from 'ng2-logger';
import { Subject } from 'rxjs/Subject';
import { AppService } from '../app.service';

import { AdminService } from '../_services/admin.service';
import {ACLFeature} from '../_models/acl-feature';

const log = Log.create('Genericsearch');

@Component({
  moduleId: module.id,
  selector: 'edit-genericsearch',
  styleUrls: ['genericsearch.less'],
  templateUrl: 'genericsearch.component.html',
})

export class GenericsearchComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private admin: AdminService,
  ) {}

  products: Array<any> = [];
  drivers: Array<any> = [];
  modules: Array<any> = [];
  sensors: Array<any> = [];
  bridges: Array<any> = [];
  sensorAccessories: Array<any> = [];
  searchQuery: String = "";
  loading: boolean = false;

  iCanReadSensors = false;
  iCanReadSensorsAccessories = false;
  iCanReadBridges = false;

  searchThreshold: Number = 2;

  private _searchChanged: Subject<string> = new Subject<string>();


  ngOnInit() {
    this.appService.headerData.title = 'Search';
    this.appService.headerData.path = [];

    this.admin.canI(ACLFeature.READ_SENSORS).subscribe((iCan: boolean) => {
      this.iCanReadSensors = iCan;
    });

    this.admin.canI(ACLFeature.READ_SENSOR_ACCESSORIES).subscribe((iCan: boolean) => {
      this.iCanReadSensorsAccessories = iCan;
    });

    this.admin.canI(ACLFeature.READ_BRIDGES).subscribe((iCan: boolean) => {
      this.iCanReadBridges = iCan;
    });


    this._searchChanged
      .debounceTime(300) // wait 300ms after the last event before emitting last event
      .distinctUntilChanged() // only emit if value is different from previous value
      .subscribe(name => {

        //only search if user searches for more than a few characters
        if(name.length >= this.searchThreshold) {
          this.loading = true;

          this.router.navigate(['/search', {query: this.searchQuery}], {relativeTo: this.route} );

          this.admin.genericSearch(name).subscribe((data) => {
            this.loading = false;

            log.d('data', data)

            this.products = data.data;
            this.drivers = data.data.drivers;
            this.modules = data.data.modules;
            this.sensors = data.data.sensors;
            this.bridges = data.data.bridges;
            this.sensorAccessories = data.data.sensorAccessories;
          });
        } else {
          this.clearData();
          this.router.navigate(['/search'], {relativeTo: this.route} );
        }
      });

    this.route.params.subscribe(params => {
      if (params['query']) {
        this.searchQuery = params['query'];
        this._searchChanged.next(params['query']);
      }
    });
  }

  public getViewStatusClass(viewStatus) {
    switch (viewStatus) {
      case 1:
        return 'edit-is-visible-in-region';
      case 2:
        return 'edit-is-in-maintenance-mode';
      case 3:
        return 'edit-is-in-archive';
      default:
        return '';
    }
  }

  ngOnDestroy() {
  }

  public onSearchChanged($event) {
    this._searchChanged.next($event);
  }

  private clearData() {
    this.products = [];
    this.drivers = [];
    this.modules = [];
    this.sensors = [];
    this.bridges = [];
    this.sensorAccessories = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/genericsearch/genericsearch.component.ts